<template>
  <div class="page">
    <PageHeader :links="headLinks" />

    <div class="pageMain">
      <div class="topbar m-b-25 d-flex flex-j-between">
        <div>
          <el-button size="small" type="primary" :disabled="!flag" @click="output">批量导出稿件附件</el-button>
        </div>

        <div class="searchBox">
          <div style="float: left; width: 300px">
            <el-input placeholder="稿件标题" v-model="f_title" class="input-with-select">
              <el-button slot="append" icon="el-icon-search" @click="loadData">搜索</el-button>
            </el-input>
          </div>
        </div>
      </div>

      <el-row>
        <el-col :span="24">
          <el-table ref="tableData" :data="tableData" stripe @select-all="selAll" @selection-change="selChange" style="width: 100%">
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column type="index" width="40" align="center"> </el-table-column>
            <el-table-column prop="sn" label="稿件编号" width="100">
              <template slot-scope="scope">
                <span class="sn">{{ scope.row.sn }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="title" label="稿件标题" min-width="200">
              <template slot-scope="scope">
                <h3>{{ scope.row.title }}</h3>
              </template>
            </el-table-column>

            <el-table-column prop="subjectName" :label="subName" width="90"></el-table-column>

            <el-table-column prop="authorName" label="作者" width="80"></el-table-column>

            <el-table-column prop="createTime" label="投稿时间" width="140">
              <template slot-scope="scope">
                {{ scope.row.createTime | datefmt2("YYYY-MM-DD HH:mm:ss") }}
              </template>
            </el-table-column>

            <el-table-column prop="expertTime" label="专家审稿完成时间" width="140">
              <template slot-scope="scope">
                {{ scope.row.expertTime | datefmt2("YYYY-MM-DD HH:mm:ss") }}
              </template>
            </el-table-column>

            <el-table-column prop="step" label="状态">
              <template slot-scope="scope">
                <el-tag type="primary" v-if="scope.row.step == 60">待查重</el-tag>
                <el-tag type="primary" v-else-if="scope.row.step == 63">待二次查重</el-tag>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>

      <div style="margin: 20px 0 0 -5px">
        <el-pagination background layout="sizes,prev, pager, next" :total="total" :page-size="pageSize" :page-sizes="[15, 30, 50, 100]" :current-page="curPage" @current-change="pageChange" @size-change="pageSizeChange"> </el-pagination>
      </div>
    </div>

    <!--el-drawer :title="drawerTitle" :visible.sync="drawer" :direction="'rtl'" :size="700" :destroy-on-close="true" :wrapperClosable="false">
      <div class="flex-1 d-flex flex-column">
        <div class="flex-1" style="padding: 0 20px 20px 20px">
          <ArticleProcess ref="ArticleProcess" :articleId="curArticleId" role="EDITOR"></ArticleProcess>
        </div>
      </div>
    </el-drawer-->
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue"
import recheckApi from "@/api/recheck"
import attachUtil from "@/utils/attachUtil"
/**
 * 待评审页面
 * 步骤,100退稿。
 * 10作者提交稿件，
 * 20待编辑首次审稿，21作者一次改稿,22编辑第二次审稿。
 * 30交审稿费。
 * 40专家首次审稿，41作者二次改稿,42专家第二次审稿。
 *
 * 50编辑查重，51作者三次改稿，52编辑二次查重。
 * 60登记版面费，出录用通知；
 * 70交版面费。
 * 80填写发票信息。
 * 90完成。
 */
export default {
  components: { PageHeader },
  data() {
    return {
      subName: process.env.VUE_APP_PLATFORM == "dx" ? "栏目" : "科目",
      headLinks: [{ path: "", title: "待查重稿件" }],
      subjects: [],
      f_subjectId: -1,
      f_title: "",
      curPage: 1,
      pageSize: 10,
      tableData: [],
      total: 0,
      drawer: false,
      drawerTitle: "",
      flag: false,
      curArticleId: 0,
    }
  },

  mounted() {
    this.loadData()
  },

  methods: {
    pageChange(curPage) {
      this.curPage = curPage
      this.loadData()
    },

    pageSizeChange(val) {
      this.pageSize = val
      this.curPage = 1
      this.loadData()
    },

    loadData() {
      this.tableData = []
      recheckApi.getDuplicateList(this.f_subjectId, this.f_title, 1, "", "", this.curPage, this.pageSize).then((res) => {
        this.tableData = res.rows
        this.total = res.total
      })
    },

    selAll() {
      this.flag = this.$refs.tableData.selection.length > 0
    },
    selChange() {
      this.flag = this.$refs.tableData.selection.length > 0
    },

    output() {
      let selRows = this.$refs.tableData.selection
      let articleIds = []
      selRows.forEach((element) => {
        articleIds.push(element.id)
      })

      recheckApi.downloadDuplicate(articleIds).then((res) => {
        if (res.type != "application/octet-stream") {
          this.$alert("下载失败", "错误", {
            confirmButtonText: "确定",
          })
        } else {
          attachUtil.download(res, "待查重稿件附件.zip")
        }
      })
    },
  },
}
</script>

<style scoped>
.searchBox::after {
  content: "";
  display: block;
  clear: both;
}
</style>
